<div class="container-list">


  <div class="sidenav_container" [@onSideNavChange]="sideNavState ? 'open' : 'close'">
    <div fxLayout="column" fxLayoutGap="10px" style="height: 100%;">
      <!-- <div class="user_menu">
      <mat-nav-list>
        <a mat-list-item>
          <img class="jim"
            src="diretório da foto"
            alt="">
          <span [@animateText]="linkText ? 'show' : 'hide'">Nome </span>
        </a>
      </mat-nav-list>
      <mat-divider></mat-divider>
    </div> -->

      <mat-accordion class="app-nav-accordion" [multi]="true" #accordion="matAccordion"
        [@animateText]="linkText ? 'show' : 'hide'">
        <div mat-list-item *ngFor="let item of menuData">

          <span *ngIf="!item.children || item.children.length === 0">
            <!-- Apenas Ícones (MENU EXPANDIDO) -->
            <mat-nav-list *ngIf="!item.hidden">
              <a mat-list-item (click)='navegar(item.route, null)'>
                <mat-icon style="vertical-align: middle; margin-right: 15px; font-size: 22px;">{{item.iconName}}
                </mat-icon>
                {{item.displayName}}
              </a>
            </mat-nav-list>
          </span>

          <!-- Com SubItens (MENU EXPANDIDO) -->
          <span *ngIf="item.children && !item.hidden">
            <!-- Cabeçalho -->
            <mat-expansion-panel [expanded]="step === item.index">
              <mat-expansion-panel-header (click)='navegar(item.route, null)' style="height: 48px; margin-top: 8px;">
                <mat-icon style="vertical-align: middle; margin-right: 15px; font-size: 22px;">{{item.iconName}}
                </mat-icon>
                {{item.displayName}}
              </mat-expansion-panel-header>

              <mat-nav-list style="background-color: #f6f6f6; border-radius: 5px;">
                <span *ngFor="let child of item.children">
                  <!-- SubItens  -->
                  <a *ngIf="!child.children && !child.hidden" mat-list-item (click)='navegar(child.route, null)'>
                    {{child.displayName}}
                  </a>

                  <!-- SubMenu  -->
                  <mat-expansion-panel *ngIf="child.children && !child.hidden">
                    <mat-expansion-panel-header (click)='navegar(item.route, null)'
                      style="height: 48px; margin-top: 8px;">
                      {{child.displayName}}
                    </mat-expansion-panel-header>

                    <mat-nav-list style="background-color: #f6f6f6; border-radius: 3px;">
                      <span *ngFor="let child of child.children">
                        <a mat-list-item (click)='navegar(child.route, null)' *ngIf="!child.hidden">
                          {{child.displayName}}
                        </a>
                      </span>
                    </mat-nav-list>
                  </mat-expansion-panel>
                </span>

              </mat-nav-list>
            </mat-expansion-panel>

          </span>

        </div>
      </mat-accordion>

      <!-- OCULTADO POR ESTAR BUGANDO O LAYOUT. REFAZER TODO O MENU -->
      <!-- Apenas Ícones (MENU RECOLHIDO) -->
      <!-- <mat-accordion class="app-nav-accordion" [multi]="true" #accordion="matAccordion"
        [@animateText]="linkText ? 'hide' : 'show'">
        <div mat-list-item *ngFor="let item of menuData">

          <span *ngIf="!item.children || item.children.length === 0">->
             Itens solo -->
            <!-- <mat-nav-list *ngIf="!item.hidden">
              <a mat-list-item (click)='navegar(item.route, null)' [matTooltip]="item.displayName"
                matTooltipPosition="right">
                <mat-icon style="font-size: 22px;">{{item.iconName}}</mat-icon>
              </a>
            </mat-nav-list>
          </span> -->

          <!-- <span *ngIf="item.children"> -->
            <!-- Com subitens -->
            <!-- <mat-nav-list *ngIf="!item.hidden">
              <a mat-list-item (click)='navegar(item.route, item.index)' [matTooltip]="item.displayName"
                matTooltipPosition="right">
                <mat-icon style="font-size: 22px;">{{item.iconName}}</mat-icon>
              </a>
            </mat-nav-list>
          </span>

        </div>
      </mat-accordion> -->


      <!-- <mat-accordion class="app-nav-accordion" [multi]="true" #accordion="matAccordion">
        <mat-nav-list>
          <a mat-list-item (click)="onSinenavToggle()" [matTooltip]="linkText ? 'Recolher' : 'Expandir'"
            matTooltipPosition="right">
            <mat-icon *ngIf="sideNavState" style="color: blue;">arrow_left</mat-icon>
            <mat-icon *ngIf="!sideNavState" style="color: blue;">arrow_right</mat-icon>
          </a>
        </mat-nav-list>
      </mat-accordion> -->
      <mat-accordion class="app-nav-accordion" [multi]="true" #accordion="matAccordion">
        <mat-nav-list>
          <a mat-list-item (click)="onSinenavToggle()" matTooltip="Versão do sistema" matTooltipPosition="right">
            <div matSubheader *ngIf="linkText" style="margin-left: 48px;">
              <mat-icon style="font-size: 18px; margin-top: 4px;">settings</mat-icon>
              <div style="font-size: 12px;">V {{sVersao}}</div>
            </div>

            <!-- <div *ngIf="!linkText">
              <div style="font-size: 8px;">V {{sVersao}}</div>
            </div> -->
          </a>
        </mat-nav-list>
      </mat-accordion>
    </div>

  </div>
</div>